import React from "react";
import Container from "src/components/atoms/Container";
import PageHeading from "src/components/molecules/PageHeading";
import Pagination from "src/components/molecules/Pagination";
import ArticleList from "src/components/organisms/Blog/ArticleList";
import { PaginationProvider } from "src/contexts/PaginationContext";
import { getBlogPosts } from "src/services/DefaultService";

const Articles: React.FC<{ blogHome: any; initialData: FindResponse<any> }> = ({
  blogHome,
  initialData,
}) => {
  const { attributes } = blogHome;
  return (
    <Container className="mb-16">
      <PaginationProvider
        queryKey={"getBlogPosts"}
        queryFunction={getBlogPosts}
        initialData={initialData}
      >
        <PageHeading
          title={attributes.title}
          description={attributes.subTitle}
        />
        <ArticleList />
        <div className="mt-10">
          <Pagination />
        </div>
      </PaginationProvider>
    </Container>
  );
};

export default Articles;
